module.exports = __webpack_public_path__ + "img/3.c10d88a2.jpg";